import styled from 'styled-components';
import { Link, Text } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import { trackEvent } from '@99designs/tracking';
import StarRating from './StarRating';

const Rating = styled(Link)`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
    gap: ${spaces['0.25bu']};
`;

const RatingText = styled(Text)`
    text-decoration: underline;
`;

export default function StarRatings() {
    return (
        <Rating
            href={`/testimonials/logo-design`}
            underline="none"
            target="_blank"
            data-testid="designer-review-rating"
            onClick={() =>
                trackEvent('Rating CTA clicked on product details page', {
                    path: '/testimonials/logo-design',
                    type: 'topRating',
                })
            }
        >
            <StarRating rating={5} />
            <RatingText size="size3" fontFamily="heading">
                4.8
            </RatingText>
            <RatingText size="size3">(26k {__('reviews')})</RatingText>
        </Rating>
    );
}
